import { BaseEdge, getBezierPath, type Edge, type EdgeProps } from '@xyflow/react';

export type TreeFlowDeleteEdgeType = Edge;

/**
 * Arête générique en courbe de Bézier, style uniforme pour tout arbre React
 * Flow. La suppression du lien vit désormais sur les nœuds (poignées
 * corbeille/ciseaux, cf. `tree-flow-node.tsx`) — plus de bouton flottant
 * sur l'arête elle-même.
 */
export function TreeFlowDeleteEdge({
  id,
  sourceX,
  sourceY,
  sourcePosition,
  targetX,
  targetY,
  targetPosition
}: EdgeProps<TreeFlowDeleteEdgeType>) {
  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition
  });

  return (
    <BaseEdge
      id={id}
      path={edgePath}
      style={{ stroke: 'hsl(var(--foreground) / 0.55)', strokeWidth: 2.5 }}
    />
  );
}
